module.exports = __webpack_public_path__ + "static/media/logo.19d8f2cf.png";